import api from '../../../App/socket';

export const searchByHotColdList = where => (
    api.send({
        api: 'db',
        model: 'Bike_variant',
        action: 'Read',
        options: {
            include: [
                {
                    path: 'ref_bike_model',
                    model: 'Bike_model',
                    attributes: 'all',
                },
                {
                    // path: 'ref_bike_variant',
                    model: 'Bike_variant',
                    attributes: 'all',
                }],
            attributes: 'all',
            limit: 10,
            where,
            order: {
                name: 'asc',
            },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/requests/search_by_hot_cold_requests.js